import { extendTheme } from '@chakra-ui/react';

const breakpoints = {
  xs: '26em',
  sm: '30em',
  md: '48em',
  lg: '62em',
  xl: '80em',
  '2xl': '96em',
};

const theme = {
  breakpoints,
  colors: {
    lightGreen: '#B4FFDF',
    teal: '#00A4AE',
    purple: '#9968fa',
    orange: '#E27715',
    white: '#f5f6f8',
    black: '#141718',
    pink: '#ff2d55',
    dripBackground: '#151718',
    dripPrimaryFill: '#1E2021',
    dripSecondaryFill: ' #282A2C',
    tintColor: '#007AFF',
  },

  styles: {
    global: {
      html: {
        backgroundColor: '#151718',
      },
      body: {
        backgroundColor: '#151718',
        color: '#f5f6f8',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        _hover: {
          backgroundColor: 'none',
        },
        _active: { backgroundColor: 'none' },
      },
    },
  },
};

export default extendTheme(theme);
